var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEquityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 107,
    viewBox: "0 0 118 94",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8711 8.62545C43.8711 4.83222 47.0005 1.76953 50.8764 1.76953C54.7524 1.76953 57.8818 4.86032 57.8818 8.62545C57.8818 12.3906 54.7524 15.4814 50.8764 15.4814C47.0005 15.4814 43.8711 12.3906 43.8711 8.62545Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4983 26.6651C61.4983 22.7876 58.254 19.6406 54.292 19.6406H47.4876C43.4968 19.6406 40.2812 22.7876 40.2812 26.6651V39.1407",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1602 8.62545C92.1602 4.83222 95.2896 1.76953 99.1655 1.76953C103.041 1.76953 106.171 4.86032 106.171 8.62545C106.171 12.3906 103.041 15.4814 99.1655 15.4814C95.2896 15.4814 92.1602 12.3906 92.1602 8.62545Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5703 26.6651C88.5703 22.7876 91.8146 19.6406 95.7766 19.6406H102.581C106.572 19.6406 109.787 22.7876 109.787 26.6651V37.8763",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0156 14.6958C68.0156 10.9025 71.1451 7.83984 75.021 7.83984C78.8969 7.83984 82.0263 10.9306 82.0263 14.6958C82.0263 18.4609 78.8969 21.5517 75.021 21.5517C71.1451 21.5517 68.0156 18.4609 68.0156 14.6958Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8438 40.0952L85.6428 32.7335C85.6428 28.856 82.3985 25.709 78.4365 25.709H71.6321C67.6701 25.709 64.4258 28.856 64.4258 32.7335V40.0952",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7056 86.4574L24.4896 91.6556C23.5995 92.1613 22.4511 91.8522 21.9343 90.9812L2.03798 57.2354C1.52119 56.3644 1.83701 55.2405 2.72703 54.7347L11.9431 49.5366C12.8331 49.0308 13.9815 49.3399 14.4983 50.2109L17.9723 56.0834L31.2939 78.6462L34.4234 83.9567C34.9402 84.8277 34.6244 85.9236 33.7343 86.4574H33.7056Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3959 55.6909L104.278 45.3789C107.924 43.1591 112.747 44.255 115.015 47.8234C115.819 49.0878 116.193 50.4927 116.193 51.8695C116.193 54.3983 114.872 56.8991 112.518 58.3602L72.122 83.0303C71.2319 83.5922 70.1984 83.8451 69.1648 83.8451C68.7054 83.8451 68.246 83.7889 67.7867 83.6765L65.9492 83.2269L38.6168 76.4272C37.1239 76.0619 35.5448 76.2586 34.2241 77.0173L31.2383 78.7032L17.9453 56.1404L26.3288 51.3638L34.1667 46.9524C39.1911 44.1145 45.2203 43.4963 50.7327 45.2103L70.0548 51.2795C73.5862 52.3753 75.5385 56.1685 74.4475 59.7089C73.5575 62.603 70.9448 64.4855 68.1025 64.4855C67.8728 64.4855 67.6144 64.4855 67.3847 64.4575",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.365 63.2495L51.5938 59.4844",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3633 63.248L65.8898 63.9505C66.4066 64.1191 66.9521 64.2315 67.4689 64.3158",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquityIcon);
export default __webpack_public_path__ + "static/media/equity-icon.d692cbf4.svg";
export { ForwardRef as ReactComponent };